export default {
	search(params, cb, ecb) {
		this.http
			.get('/roast', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get('/roast/' + id, {}).then((r) => cb && cb(r))
	},
	delete(id, cb, ecb) {
		this.http
			.delete('/roast/' + id, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	start(form, cb, ecb) {
		this.http
			.post('/roast/start', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	complete(form, cb, ecb) {
		this.http
			.post('/roast/complete', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	undoComplete(id, cb, ecb) {
		this.http
			.get(`/roast/${id}/undo`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	cancel(id, cb, ecb) {
		this.http
			.get(`/roast/${id}/cancel`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateProfile(form, cb, ecb) {
		this.http
			.post('/roast/profile', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getProfileById(id, cb) {
		this.http.get('/roast/profile/' + id, {}).then((r) => cb && cb(r))
	},
	getProfileByRoastId(id, cb) {
		this.http.get(`/roast/${id}/profile`, {}).then((r) => cb && cb(r))
	},
	saveRecipe(roastid, cb, ecb) {
		// 从roast保存方案
		this.http
			.post(`/roast/${roastid}/saverecipe`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchRecipe(params, cb, ecb) {
		this.http
			.get('/roast/recipe', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateRecipe(form, cb, ecb) {
		this.http
			.post('/roast/recipe', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getRecipeById(id, cb) {
		this.http.get('/roast/recipe/' + id, {}).then((r) => cb && cb(r))
	},
	deleteRecipe(id, options, cb, ecb) {
		const clearAssociations = !!(options && options.clear_associations)
		this.http
			.delete('/roast/recipe/' + id, {
				data: { clear_associations: clearAssociations },
				params: { clear_associations: clearAssociations }
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	linkRecipe(roastId, recipeId, cb, ecb) {
		this.http
			.post(`/roast/${roastId}/linkrecipe`, { recipe_id: recipeId })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	matchRecipe(roastId, cb, ecb) {
		this.http
			.post(`/roast/${roastId}/matchrecipe`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
